// UserEditManual.jsx
import {
  useGetOne,
  useDataProvider,
  useNotify,
  useRedirect,
  PasswordInput,
  SelectInput,
  useGetList,
} from "react-admin";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  CircularProgress,
  IconButton,
  TextField,
  FormControlLabel,
  Switch,
  Avatar,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useParams } from "react-router-dom";
import { useForm, Controller, useFieldArray, FormProvider } from "react-hook-form";
import { PermissionsInput } from "../components/PermissionsInput";
import { useEffect, useState } from "react";
import { PERMISSION_TEMPLATE } from "./utils/permissions.constants";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
export const UserEdit = () => {
  const { id } = useParams(); // userId
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  const [adminToDelete, setAdminToDelete] = useState(null); // { _id, index }
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmDeleteProviderOpen, setConfirmDeleteProviderOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState(0); // Estado para los tabs
  const handleDeleteAdmin = async () => {
    if (adminToDelete?._id) {
      try {
        await dataProvider.delete("user", { id: adminToDelete._id });
        notify("Administrador eliminado con éxito", { type: "success" });
      } catch (error) {
        console.error(error);
        notify("Error al eliminar el administrador", { type: "error" });
      }
    }
    // Quitar del formulario, incluso si no tenía _id
    remove(adminToDelete.index);
    setConfirmOpen(false);
    setAdminToDelete(null);
  };
  const handleDeleteProvider = async () => {
    try {
      await dataProvider.delete("user", { id });
      notify("Proveedor eliminado correctamente", { type: "success" });
      redirect("list", "providers");
    } catch (error) {
      console.error(error);
      notify("Error al eliminar el proveedor", { type: "error" });
    } finally {
      setConfirmDeleteProviderOpen(false);
    }
  };
  /* 1️⃣ Trae el usuario */
  const { data: user, isLoading } = useGetOne("providers", { id });
  const { data: branches = [], isLoading: loadingBranches } = useGetList("enterprise/branches", {
    filter: { providerId: id },
  });
  /* 2️⃣ Hook‐form */
  const methods = useForm({
    defaultValues: {
      first_name: "",
      business_name: "",
      email: "",
      phone: "",
      CI_NIT: "",
      role: "",
      email_verified: false,
      provider_verified: false,
      state: false,
      providerEnabledForApp: false,
      reminderConfirmed: false,
      whatsappLinked: false,
      branchAdmins: [],
    },
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;
  //   const BranchSelectInput = ({ providerId, name, ...props }) => {
  //     const { data, isLoading, error } = useGetList("enterprise/branches", {
  //       filter: { providerId },
  //     });

  //     if (isLoading) return <span>Cargando sucursales...</span>;
  //     if (error) return <span>Error al cargar sucursales</span>;

  //     return (
  //         <SelectInput
  //             source={name}
  //             choices={data}
  //             optionText="name"
  //             optionValue="_id"
  //             parse={(value) => data.find((branch) => branch._id === value)}
  //             format={(value) => value?._id || value}
  //             sx={{
  //                 mt: 0, // o marginTop: 0
  //                 "& .MuiSelect-select": {
  //                 padding: "16.5px 14px",
  //                 },
  //             }}
  //             {...props}
  //         />
  //     );
  //   };
  const BranchSelectInput = ({ name, ...props }) => (
    <SelectInput
      source={name}
      choices={branches} // ← usa la lista cargada arriba
      optionText="name"
      optionValue="_id"
      parse={(id) => branches.find((b) => b._id === id)} // guarda objeto
      format={(obj) => obj?._id}
      sx={{
        mt: 0, // margin-top: 0 al contenedor principal
        "& .MuiSelect-select": {
          paddingTop: "16px",
          paddingBottom: "16px",
        },
      }} // muestra id
      {...props}
    />
  );
  /* 3️⃣ Arreglo dinámico branchAdmins */
  const { fields, append, remove } = useFieldArray({
    control,
    name: "branchAdmins",
  });

  /* 4️⃣ Cuando llega el usuario, rellena el form */
  useEffect(() => {
    if (user && !loadingBranches) {
      const admins = (user.branchAdmins || []).map((ba) => {
        /* si branch es string ⇒ conviértelo a objeto usando la lista */
        const branchObj = typeof ba.branch === "string" ? branches.find((b) => b._id === ba.branch) : ba.branch;

        return {
          ...ba,
          branch: branchObj ?? ba.branch, // deja lo que había si no lo encuentra
          permissions: ba.permissions ?? JSON.parse(JSON.stringify(PERMISSION_TEMPLATE)),
        };
      });

      reset({ ...user, branchAdmins: admins });
    }
  }, [user, branches, loadingBranches, reset]);
  // console.log('USER',user)
  /* 5️⃣ Guardar */
  const onSubmit = async (values) => {
    try {
      console.log("VALUES", values);
      await dataProvider.update("providers", { id, data: values });
      notify("Actualizado correctamente", { type: "success" });
      redirect("list", "providers");
    } catch (error) {
      console.error(error);
      notify("Error al actualizar", { type: "error" });
    }
  };

  if (isLoading || !user) return <CircularProgress />;
  const Row = ({ label, value }) => (
    <Box display="flex" justifyContent="space-between">
      <Typography fontWeight={500}>{label}</Typography>
      <Typography>{value}</Typography>
    </Box>
  );
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          {/* ───────── Columna 1 ───────── */}
          <Grid item xs={12} md={4}>
            {/* ░▒█ Info general */}
            <Card sx={{ borderRadius: 3, p: 2, mb: 3, mt: 2.5 }}>
              <CardContent>
                {/* ── Header con imagen y botón ── */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Avatar src={user?.pictureURL} sx={{ width: 56, height: 56 }} variant="rounded" />
                  {/* <IconButton>
                                <MoreVertIcon />
                            </IconButton> */}
                </Box>
                {/* ── Nombre de empresa y descripción ── */}
                <Typography variant="h6" fontWeight={600} mt={2}>
                  {user?.first_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {user?.business_name}
                </Typography>

                <Divider sx={{ my: 2 }} />

                {/* ── Datos clave ── */}
                <Box display="flex" flexDirection="column" gap={1}>
                  <Row label="Nit" value={user?.CI_NIT} />
                  <Row label="Teléfono" value={user?.phone} />
                  <Row label="Correo" value={user?.email} />
                  <Row
                    label="Estado"
                    value={
                      <Chip
                        label={user?.state ? "Activo" : "Inactivo"}
                        color={user?.state ? "success" : "default"}
                        size="small"
                      />
                    }
                  />
                  {/* <TextField source="role" label="Rol" /> */}
                  <Row label="Rol" value={user?.role || "No definida"} />
                  <Row
                    label="Email Verificado"
                    value={
                      user?.email_verified ? (
                        <Chip icon={<CheckIcon />} label="Verificado" color="success" size="small" />
                      ) : (
                        <Chip icon={<CloseIcon />} label="No verificado" color="default" size="small" />
                      )
                    }
                  />
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                      <Typography fontWeight={500} mt={2}>
                        Plan de Suscripción
                      </Typography>
                      <Controller
                        name="plan"
                        control={control}
                        defaultValue="standard"
                        render={({ field }) => (
                          <SelectInput
                            {...field}
                            label={false}
                            source="plan"
                            choices={[
                              { id: "freemium", name: "Freemium" },
                              { id: "standard", name: "Standard" },
                              { id: "franquicia", name: "Franquicia" },
                              { id: "enterprise", name: "Enterprise" },
                            ]}
                            sx={{ minWidth: 160 }}
                          />
                        )}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                      <Typography fontWeight={500} mt={2}>
                        Estado de Suscripción
                      </Typography>
                      <Controller
                        name="subscription.status"
                        control={control}
                        defaultValue="PAID"
                        render={({ field }) => (
                          <SelectInput
                            {...field}
                            label={false}
                            source="subscription.status"
                            choices={[
                              { id: "FREE_TRIAL", name: "Prueba Gratuita" },
                              { id: "PENDING", name: "Pendiente" },
                              { id: "PAID", name: "Pagado" },
                              { id: "CANCELLED", name: "Cancelado" },
                            ]}
                            sx={{ minWidth: 160 }}
                          />
                        )}
                      />
                    </Box>
                  </Grid>
                </Box>
              </CardContent>
            </Card>

            {/* ░▒█ Config extras */}
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Configuraciones Adicionales
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <Controller
                  name="provider_verified"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <FormControlLabel
                      control={<Switch checked={value} onChange={onChange} />}
                      label="Proveedor verificado"
                    />
                  )}
                />

                <Controller
                  name="state"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <FormControlLabel
                      control={<Switch checked={value} onChange={onChange} />}
                      label="Usuario habilitado"
                    />
                  )}
                />

                <Controller
                  name="providerEnabledForApp"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <FormControlLabel
                      control={<Switch checked={value} onChange={onChange} />}
                      label="Habilitado para app móvil"
                    />
                  )}
                />
                <Controller
                  name="providerEnabledForWeb"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <FormControlLabel
                      control={<Switch checked={value} onChange={onChange} />}
                      label="Habilitar Private Landing"
                    />
                  )}
                />
                <Controller
                  name="reminderConfirmed"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <FormControlLabel
                      control={<Switch checked={value} onChange={onChange} />}
                      label="Confirmación de recordatorio"
                    />
                  )}
                />

                <Controller
                  name="whatsappLinked"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <FormControlLabel
                      control={<Switch checked={value} onChange={onChange} />}
                      label="WhatsApp vinculado"
                    />
                  )}
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={8}>
            <Card variant="outlined" sx={{ borderRadius: 3, p: 2, mb: 3, mt: 2.5 }}>
              <CardContent>
                {/* Tabs de navegación */}
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
                  <Tabs value={currentTab} onChange={(e, newValue) => setCurrentTab(newValue)} aria-label="admin tabs">
                    <Tab label="Administradores de Sucursal" />
                    <Tab label="Historial de Facturas" />
                  </Tabs>
                </Box>

                {/* Tab Content */}
                {currentTab === 0 && (
                  <Box>
                    <Typography variant="h6" gutterBottom>
                      Administradores de Sucursal
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    {fields.map((field, index) => (
                      <Box
                        key={field.id}
                        sx={{
                          position: "relative",
                          border: "1px solid #e0e0e0",
                          borderRadius: 2,
                          p: 2,
                          mb: 2,
                          "&:hover .delete-button": {
                            display: "block",
                          },
                        }}
                      >
                        <Grid container spacing={1} sx={{ mt: 2 }}>
                          <Grid item xs={12} md={6}>
                            <Controller
                              control={control}
                              name={`branchAdmins.${index}.email`}
                              rules={{ required: true }}
                              render={({ field }) => (
                                <TextField {...field} label="Correo Electrónico" sx={{ padding: 0 }} fullWidth />
                              )}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Controller
                              control={control}
                              name={`branchAdmins.${index}.branch`}
                              rules={{ required: true }}
                              render={({ field }) => (
                                <BranchSelectInput
                                  {...field}
                                  name={`branchAdmins.${index}.branch`}
                                  label="Sucursal"
                                  fullWidth
                                />
                              )}
                            />
                          </Grid>

                          <Box
                            sx={{
                              position: "absolute",
                              top: 5,
                              right: 8,
                              display: "none",
                              zIndex: 1,
                            }}
                            className="delete-button"
                          >
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => {
                                setAdminToDelete({ _id: field._id, index });
                                setConfirmOpen(true);
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </Box>

                          {!field._id && (
                            <Grid item xs={12} md={6}>
                              <Controller
                                control={control}
                                name={`branchAdmins.${index}.password`}
                                rules={{ required: true }}
                                render={({ field }) => <PasswordInput {...field} label="Contraseña" fullWidth />}
                              />
                            </Grid>
                          )}

                          <Grid item xs={12}>
                            <PermissionsInput source={`branchAdmins.${index}.permissions`} control={control} />
                          </Grid>
                        </Grid>
                      </Box>
                    ))}

                    <Button
                      startIcon={<AddIcon />}
                      variant="outlined"
                      onClick={() =>
                        append({
                          email: "",
                          password: "",
                          branch: null,
                          permissions: JSON.parse(JSON.stringify(PERMISSION_TEMPLATE)),
                        })
                      }
                    >
                      Añadir administrador
                    </Button>
                  </Box>
                )}

                {currentTab === 1 && (
                  <Box>
                    <Typography variant="h6" gutterBottom>
                      Historial de Facturas
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    {user?.subscription?.bills && user.subscription.bills.length > 0 ? (
                      <TableContainer component={Paper} sx={{ boxShadow: 1 }}>
                        <Table>
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                              <TableCell>
                                <strong>Fecha de Pago</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Plan</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Monto</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Próximo Pago</strong>
                              </TableCell>
                              <TableCell>
                                <strong>Estado</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {user.subscription.bills.map((bill, index) => (
                              <TableRow
                                key={index}
                                sx={{
                                  "&:hover": { backgroundColor: "#fafafa" },
                                  backgroundColor: bill.status === "PAID" ? "#f1f8e9" : "#fff3e0",
                                }}
                              >
                                <TableCell>
                                  <Typography variant="body1" fontWeight={500}>
                                    {bill.paid_at ? new Date(bill.paid_at).toLocaleDateString("es-ES") : "N/A"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label={bill.plan || "N/A"}
                                    color="primary"
                                    size="small"
                                    sx={{ textTransform: "capitalize", color: "white" }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Typography variant="h6" color="primary" fontWeight={600}>
                                    {bill.amount} {bill.currency}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body1">
                                    {bill.next_payment_date
                                      ? new Date(bill.next_payment_date).toLocaleDateString("es-ES")
                                      : "N/A"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label={bill.status === "PAID" ? "Pagado" : bill.status}
                                    color={bill.status === "PAID" ? "success" : "warning"}
                                    size="small"
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <Box
                        sx={{
                          textAlign: "center",
                          py: 6,
                          backgroundColor: "#f5f5f5",
                          borderRadius: 2,
                          border: "1px dashed #ccc",
                        }}
                      >
                        <Typography variant="h6" color="textSecondary" gutterBottom>
                          📄 No hay facturas registradas
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Las facturas aparecerán aquí cuando se realicen pagos
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Botón guardar */}
        <Box
          sx={{
            pt: 2,
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            pb: 2,
            backgroundColor: "#f5f5f5",
          }}
        >
          <Button type="submit" variant="contained" disabled={isSubmitting} sx={{ ml: 2, color: "white" }}>
            Guardar cambios
          </Button>
          <Box>
            <Button variant="outlined" color="error" onClick={() => setConfirmDeleteProviderOpen(true)}>
              Eliminar
            </Button>
          </Box>
        </Box>
        <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
          <DialogTitle>¿Eliminar administrador?</DialogTitle>
          <DialogContent>¿Estás seguro de que deseas eliminar este administrador de sucursal?</DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmOpen(false)} color="inherit">
              Cancelar
            </Button>
            <Button onClick={handleDeleteAdmin} color="error" variant="contained">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={confirmDeleteProviderOpen} onClose={() => setConfirmDeleteProviderOpen(false)}>
          <DialogTitle>¿Eliminar proveedor?</DialogTitle>
          <DialogContent>
            Esta acción eliminará permanentemente al proveedor y sus datos relacionados. ¿Deseas continuar?
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmDeleteProviderOpen(false)} color="inherit">
              Cancelar
            </Button>
            <Button onClick={handleDeleteProvider} color="error" variant="contained">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </FormProvider>
  );
};
